"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: auth/profile.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fauth%2Fprofile.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = exports.Key = void 0;
const alias_1 = require("../common/alias");
const step_user_group_1 = require("../common/step-user-group");
const account_closure_1 = require("./account-closure");
const protobufPackage = 'com.step.auth.proto';
function createBaseKey() {
    return { id: '', jwkBase64: '', factors: 0, deviceId: '', hasPassword: false };
}
exports.Key = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            jwkBase64: isSet(object.jwkBase64) ? globalThis.String(object.jwkBase64) : '',
            factors: isSet(object.factors) ? globalThis.Number(object.factors) : 0,
        };
        if (isSet(object.deviceId)) {
            message.deviceId = globalThis.String(object.deviceId);
        }
        if (isSet(object.hasPassword)) {
            message.hasPassword = globalThis.Boolean(object.hasPassword);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.jwkBase64 !== '') {
            obj.jwkBase64 = message.jwkBase64;
        }
        if (message.factors !== 0) {
            obj.factors = Math.round(message.factors);
        }
        if (message.deviceId !== undefined && message.deviceId !== '') {
            obj.deviceId = message.deviceId;
        }
        if (message.hasPassword !== undefined && message.hasPassword !== false) {
            obj.hasPassword = message.hasPassword;
        }
        return obj;
    },
    create(base) {
        return exports.Key.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseKey();
        message.id = object.id ?? '';
        message.jwkBase64 = object.jwkBase64 ?? '';
        message.factors = object.factors ?? 0;
        message.deviceId = object.deviceId ?? '';
        message.hasPassword = object.hasPassword ?? false;
        return message;
    },
};
function createBaseProfile() {
    return {
        verifiedAliases: [],
        unverifiedAliases: [],
        blocked: false,
        suspended: false,
        createdAtMs: '0',
        suspendedAtMs: '0',
        blockedAtMs: '0',
        closedAtMs: '0',
        closure: undefined,
        groups: [],
    };
}
exports.Profile = {
    fromJSON(object) {
        const message = {
            verifiedAliases: globalThis.Array.isArray(object?.verifiedAliases)
                ? object.verifiedAliases.map((e) => alias_1.Alias.fromJSON(e))
                : [],
            unverifiedAliases: globalThis.Array.isArray(object?.unverifiedAliases)
                ? object.unverifiedAliases.map((e) => alias_1.Alias.fromJSON(e))
                : [],
            blocked: isSet(object.blocked) ? globalThis.Boolean(object.blocked) : false,
            suspended: isSet(object.suspended) ? globalThis.Boolean(object.suspended) : false,
            groups: globalThis.Array.isArray(object?.groups)
                ? object.groups.map((e) => (0, step_user_group_1.stepUserGroupFromJSON)(e))
                : [],
        };
        if (isSet(object.createdAtMs)) {
            message.createdAtMs = globalThis.String(object.createdAtMs);
        }
        if (isSet(object.suspendedAtMs)) {
            message.suspendedAtMs = globalThis.String(object.suspendedAtMs);
        }
        if (isSet(object.blockedAtMs)) {
            message.blockedAtMs = globalThis.String(object.blockedAtMs);
        }
        if (isSet(object.closedAtMs)) {
            message.closedAtMs = globalThis.String(object.closedAtMs);
        }
        if (isSet(object.closure)) {
            message.closure = account_closure_1.AccountClosure.fromJSON(object.closure);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.verifiedAliases?.length) {
            obj.verifiedAliases = message.verifiedAliases.map((e) => alias_1.Alias.toJSON(e));
        }
        if (message.unverifiedAliases?.length) {
            obj.unverifiedAliases = message.unverifiedAliases.map((e) => alias_1.Alias.toJSON(e));
        }
        if (message.blocked !== false) {
            obj.blocked = message.blocked;
        }
        if (message.suspended !== false) {
            obj.suspended = message.suspended;
        }
        if (message.createdAtMs !== undefined && message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.suspendedAtMs !== undefined && message.suspendedAtMs !== '0') {
            obj.suspendedAtMs = message.suspendedAtMs;
        }
        if (message.blockedAtMs !== undefined && message.blockedAtMs !== '0') {
            obj.blockedAtMs = message.blockedAtMs;
        }
        if (message.closedAtMs !== undefined && message.closedAtMs !== '0') {
            obj.closedAtMs = message.closedAtMs;
        }
        if (message.closure !== undefined) {
            obj.closure = account_closure_1.AccountClosure.toJSON(message.closure);
        }
        if (message.groups?.length) {
            obj.groups = message.groups.map((e) => (0, step_user_group_1.stepUserGroupToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.Profile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProfile();
        message.verifiedAliases = object.verifiedAliases?.map((e) => alias_1.Alias.fromPartial(e)) || [];
        message.unverifiedAliases = object.unverifiedAliases?.map((e) => alias_1.Alias.fromPartial(e)) || [];
        message.blocked = object.blocked ?? false;
        message.suspended = object.suspended ?? false;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.suspendedAtMs = object.suspendedAtMs ?? '0';
        message.blockedAtMs = object.blockedAtMs ?? '0';
        message.closedAtMs = object.closedAtMs ?? '0';
        message.closure = (object.closure !== undefined && object.closure !== null)
            ? account_closure_1.AccountClosure.fromPartial(object.closure)
            : undefined;
        message.groups = object.groups?.map((e) => e) || [];
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=profile.js.map